var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75,21h-5.5c-0.41,0-0.75-0.34-0.75-0.75v-8.5C8.5,11.34,8.84,11,9.25,11h5.5c0.41,0,0.75,0.34,0.75,0.75v8.5 C15.5,20.66,15.16,21,14.75,21z M10,19.5h4v-7h-4V19.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25,21H6.75C5.23,21,4,19.77,4,18.25v-8C4,9.84,4.34,9.5,4.75,9.5S5.5,9.84,5.5,10.25v8c0,0.69,0.56,1.25,1.25,1.25h10.5 c0.69,0,1.25-0.56,1.25-1.25v-4c0-0.41,0.34-0.75,0.75-0.75S20,13.84,20,14.25v4C20,19.77,18.77,21,17.25,21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75,13.5c-0.2,0-0.4-0.08-0.55-0.24c-0.28-0.31-0.26-0.78,0.04-1.06l9.54-8.79c0.67-0.62,1.69-0.62,2.36-0.01 c1.81,1.65,6.84,6.24,9.62,8.8c0.3,0.28,0.32,0.76,0.04,1.06c-0.28,0.3-0.75,0.33-1.06,0.04c-2.78-2.56-7.8-7.15-9.61-8.8 c-0.09-0.09-0.24-0.08-0.33,0L2.26,13.3C2.11,13.43,1.93,13.5,1.75,13.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.75317dbaf65a3b47b8d5b6e5917a1555.svg";
export { ForwardRef as ReactComponent };